import type { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "Data/Redux/Store";
import type { AnalyticsEventState } from "Interfaces";

const initialState: AnalyticsEventState = {
	email: false,
	alarmOut: false,
	interval: 0,
	recording: false,
	snapshot: false,
	whiteLight: false,
	audioAlarm: false,
	redBlueLight: false,
	ftp: false
};

const setAnalyticsEventReducer = (state: AnalyticsEventState, action: PayloadAction<AnalyticsEventState>) => {
	return action.payload;
};

const getAnalyticsEvent = (state: AnalyticsEventState) => {
	return state;
};

const analyticsEventSlice = createAppSlice({
	initialState,
	name: "analyticsEvent",
	reducers: {
		setAnalyticsEventAction: setAnalyticsEventReducer
	},
	selectors: {
		selectAnalyticsEvent: getAnalyticsEvent
	}
});

export default analyticsEventSlice;

export const { setAnalyticsEventAction } = analyticsEventSlice.actions;
export const { selectAnalyticsEvent } = analyticsEventSlice.selectors;
